const FB = {
  c1: "#922c88",
  c2: "#4556ac",
  c3: "#af67a4",
  c4: "#743c6e",
  c5: "#4b5480",
  c6: "#795d75",
  c1_10: "rgba(146, 44, 136, 0.1)",
  primary: "#303030",
  foreground: "#ffffff",
  separator: "#d7d7d7"
};

const pick = (v: string | undefined | null, fb: string) =>
  v && String(v).trim() !== "" ? String(v).trim() : fb;

export const ReactifyChartColors = () => {
  const rootStyle = getComputedStyle(document.documentElement);
  const c1 = pick(
    rootStyle.getPropertyValue("--reactify-theme-color-1"),
    FB.c1
  );
  return {
    ReactifyChartColor1: c1,
    ReactifyChartColor2: pick(
      rootStyle.getPropertyValue("--reactify-theme-color-2"),
      FB.c2
    ),
    ReactifyChartColor3: pick(
      rootStyle.getPropertyValue("--reactify-theme-color-3"),
      FB.c3
    ),
    ReactifyChartColor4: pick(
      rootStyle.getPropertyValue("--reactify-theme-color-4"),
      FB.c4
    ),
    ReactifyChartColor5: pick(
      rootStyle.getPropertyValue("--reactify-theme-color-5"),
      FB.c5
    ),
    ReactifyChartColor6: pick(
      rootStyle.getPropertyValue("--reactify-theme-color-6"),
      FB.c6
    ),
    ReactifyChartColor1_10: pick(
      rootStyle.getPropertyValue("--reactify-theme-color-1-10"),
      FB.c1_10
    ),
    ReactifyChartColor2_10: pick(
      rootStyle.getPropertyValue("--reactify-theme-color-2-10"),
      "rgba(69, 86, 172, 0.1)"
    ),
    ReactifyChartColor3_10: pick(
      rootStyle.getPropertyValue("--reactify-theme-color-3-10"),
      "rgba(175, 103, 164, 0.1)"
    ),
    ReactifyChartColor4_10: pick(
      rootStyle.getPropertyValue("--reactify-theme-color-4-10"),
      "rgba(116, 60, 110, 0.1)"
    ),
    ReactifyChartColor5_10: pick(
      rootStyle.getPropertyValue("--reactify-theme-color-5-10"),
      "rgba(75, 84, 128, 0.1)"
    ),
    ReactifyChartColor6_10: pick(
      rootStyle.getPropertyValue("--reactify-theme-color-6-10"),
      "rgba(121, 93, 117, 0.1)"
    ),
    primaryColor: pick(rootStyle.getPropertyValue("--primary-color"), FB.primary),
    foregroundColor: pick(
      rootStyle.getPropertyValue("--reactify-foreground-color"),
      FB.foreground
    ),
    separatorColor: pick(
      rootStyle.getPropertyValue("--reactify-separator-color"),
      FB.separator
    )
  };
};

/** Visible bar fill from theme primary (10% tint is often too faint on cards). */
export const reactifyBarFillColor = () => {
  const { ReactifyChartColor1 } = ReactifyChartColors();
  const c = ReactifyChartColor1;
  if (c.startsWith("#") && (c.length === 7 || c.length === 4)) {
    const h =
      c.length === 4
        ? `#${c[1]}${c[1]}${c[2]}${c[2]}${c[3]}${c[3]}`
        : c;
    const n = parseInt(h.slice(1), 16);
    const r = (n >> 16) & 255;
    const g = (n >> 8) & 255;
    const b = n & 255;
    return `rgba(${r},${g},${b},0.42)`;
  }
  const m = c.match(/^rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)/i);
  if (m) {
    return `rgba(${m[1]},${m[2]},${m[3]},0.42)`;
  }
  return "rgba(146, 44, 136, 0.42)";
};
